import React from 'react'
import styles from './styles/NewsItem.module.css'
import { Button, Col, Image, Popconfirm, Row, Tooltip, Typography } from 'antd'
import dayjs from 'dayjs'

export default function NewsItem(props) {
  const item = props.item
  const imagesLayout = []

  if (item.images) {
    item.images.forEach((image) => {
      imagesLayout.push(<Image key={image.url} preview={false} src={image.url} alt={image.url} />)
    })
  }

  const getDateLayout = (item) => {
    if (item.start_year && item.start_year === item.end_year) {
      item.start_year = null
    }
    const showDatetime = (date, time) => {
      if (date && time) {
        const dateStr = dayjs(date + time)
          .format('MMMM D YYYY/hh:mma')
          .split('/')[0]
        const timeStr = dayjs(date + time)
          .format('MMMM D YYYY/hh:mma')
          .split('/')[1]

        return (
          <>
            <span>{dateStr}</span> <span>{timeStr}</span>
          </>
        )
      }
      if (date) return <span>{dayjs(date).format('MMMM D YYYY')}</span>
      return null
    }
    if (item.start_date && item.end_date) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {showDatetime(item.start_date, item.start_time)}
          <span>to</span>
          {showDatetime(item.end_date, item.end_time)}
        </div>
      )
    }
    if (item.start_date) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {showDatetime(item.start_date, item.start_time)}
        </div>
      )
    }
    if (item.end_date) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>{showDatetime(item.end_date, item.end_time)}</div>
      )
    }
    if (item.year) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span>{item.year}</span>
        </div>
      )
    }
    return null
  }

  const getImagesLayout = (item) => {
    if (imagesLayout.length > 0) {
      return <div style={{ width: '100%', marginTop: 24, display: 'flex', flexDirection: 'row', gap: 4 }}>{imagesLayout}</div>
    }
    if (item.thumbnails) {
      return (
        <div style={{ width: '100%', marginTop: 24, display: 'flex', flexDirection: 'row', gap: 4 }}>
          <img style={{ width: '100%', height: '100%', maxWidth: 720 }} src={item.thumbnails} alt={'thumbnails'} />
        </div>
      )
    }
  }

  const getBodyLayout = (item) => {
    if (item.body) {
      return <div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: item.body }}></div>
    }
    const layout = []
    if (item.location) {
      layout.push(<div style={{ width: '100%', paddingBottom: 4 }} dangerouslySetInnerHTML={{ __html: item.location }}></div>)
    }
    if (item.desc) {
      layout.push(<div style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: item.desc }}></div>)
    }
    if (item.link) {
      layout.push(
        <div style={{ width: '100%', marginTop: 4 }}>
          <a href={item.link} style={{ textDecoration: 'underline' }}>
            View More
          </a>
        </div>
      )
    }
    return <div>{layout}</div>
  }
  return (
    <div
      style={{
        width: '100%',
        borderTop: '1px solid rgba(0, 0, 0, 0.15)',
        paddingTop: 6,
        paddingBottom: 6
      }}
    >
      <div style={{ width: '100%', padding: 6, display: 'flex', flexDirection: 'row' }}>
        <Button
          type={'primary'}
          onClick={() => {
            props.onUpdate()
          }}
        >
          Edit
        </Button>
        <Popconfirm
          placement='bottom'
          title='  Are you sure to delete it?  '
          onConfirm={() => {
            props.onDelete()
          }}
          onCancel={() => {}}
          okText='Confirm'
          cancelText='Cancel'
        >
          <Button
            danger
            onClick={() => {
              props.onDelete()
            }}
          >
            Delete
          </Button>
        </Popconfirm>
      </div>
      <Row spacing={4}>
        <Col xs={6}>
          <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>{getDateLayout(item)}</div>
        </Col>
        <Col xs={18}>
          <div style={{ display: 'flex', width: '100%', marginTop: 3, gap: 2, flexDirection: 'column' }}>
            {item.title && (
              <Tooltip title='News Title'>
                {item.link && (
                  <Typography variant={'h2'} className={styles.title}>
                    <a href={'https://' + item.link}>{item.title}</a>
                  </Typography>
                )}
                {!item.link && (
                  <Typography variant={'h2'} className={styles.title}>
                    {item.title}
                  </Typography>
                )}
              </Tooltip>
            )}
            {getImagesLayout(item)}
            {getBodyLayout(item)}
          </div>
        </Col>
      </Row>
    </div>
  )
}
